import { render, staticRenderFns } from "./service.vue?vue&type=template&id=0da62aa3&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=0da62aa3&prod&lang=less"
import style1 from "./service.vue?vue&type=style&index=1&id=0da62aa3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da62aa3",
  null
  
)

export default component.exports